import React from "react";
import style from "./style.scss";

import Header from "../header/index";

// El Header ahora integra todo: nav links + cuenta logueada + login dropdown +
// server status. El antiguo <Login/> como panel separado fue eliminado.
class MainContainer extends React.Component {
    render() {
        const { userAgent } = this.props;

        // Header afuera del .container constrained → ocupa full width
        // (mismo comportamiento que /play, donde el Header se monta
        // suelto sin MainContainer). Los children quedan dentro del
        // 913px wrapper como antes.
        return (
            <React.Fragment>
                <Header userAgent={userAgent} />
                <div className={style.container}>
                    {this.props.children}
                </div>
            </React.Fragment>
        );
    }
}

export default MainContainer;
